export default {
  edit_selection: 'Modifier la sélection',
};
